import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useGlobals} from '../../../../../../../globalPropsContext';

export const useProductQuickAddAddToCartButtonText = (productId: string, canAddProductToCart: boolean) => {
  const {textsMap, productsManifest} = useGlobals();
  const {addToCartState} = productsManifest[productId];
  const {selectOptionsButtonText, galleryAddToCartPreOrderButtonText, galleryAddToCartButtonText} = textsMap;

  if (!canAddProductToCart) {
    return selectOptionsButtonText;
  }

  if (addToCartState === AddToCartState.PRE_ORDER) {
    return galleryAddToCartPreOrderButtonText;
  }

  return galleryAddToCartButtonText;
};
